import { render, staticRenderFns } from "./dashboardStatePage.vue?vue&type=template&id=2cfda96d"
import script from "./dashboardStatePage.vue?vue&type=script&lang=js"
export * from "./dashboardStatePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports